import { SalesProductSummary } from './salesProductsApi';
import { apiClient } from './apiClient';

export type ProspectCampaignTag = {
  id: string;
  name: string;
  createdByUserId: string;
  createdAtUtc: string;
  updatedAtUtc: string;
  products?: SalesProductSummary[];
};

export type ProspectCampaignTagListResult = {
  items: ProspectCampaignTag[];
  totalCount: number;
  page: number;
  pageSize: number;
};

export type ProspectCampaignTagListFilter = {
  page?: number;
  pageSize?: number;
};

export async function listCampaignTags(filter: ProspectCampaignTagListFilter = {}): Promise<ProspectCampaignTagListResult> {
  const response = await apiClient.get<ProspectCampaignTagListResult>('/v1/sales/campaign-tags', {
    params: filter,
  });
  return {
    items: response.data.items ?? [],
    totalCount: response.data.totalCount ?? 0,
    page: response.data.page ?? 1,
    pageSize: response.data.pageSize ?? 25,
  };
}

export async function getCampaignTag(id: string): Promise<ProspectCampaignTag> {
  const response = await apiClient.get<ProspectCampaignTag>(`/v1/sales/campaign-tags/${id}`);
  return response.data;
}

export async function getCampaignProducts(id: string): Promise<SalesProductSummary[]> {
  const response = await apiClient.get<SalesProductSummary[]>(`/v1/sales/campaign-tags/${id}/products`);
  return response.data;
}

export async function replaceCampaignProducts(id: string, productIds: string[]): Promise<void> {
  await apiClient.put(`/v1/sales/campaign-tags/${id}/products`, { productIds });
}

export async function createCampaignTag(name: string): Promise<ProspectCampaignTag> {
  const response = await apiClient.post<ProspectCampaignTag>('/v1/sales/campaign-tags', { name: name.trim() });
  return response.data;
}

export async function updateCampaignTag(id: string, name: string): Promise<ProspectCampaignTag> {
  const response = await apiClient.put<ProspectCampaignTag>(`/v1/sales/campaign-tags/${id}`, { name: name.trim() });
  return response.data;
}

export async function deleteCampaignTag(id: string): Promise<void> {
  await apiClient.delete(`/v1/sales/campaign-tags/${id}`);
}
